import { render, staticRenderFns } from "./Gw.vue?vue&type=template&id=0efabbce&scoped=true"
import script from "./Gw.vue?vue&type=script&lang=js"
export * from "./Gw.vue?vue&type=script&lang=js"
import style0 from "./Gw.vue?vue&type=style&index=0&id=0efabbce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0efabbce",
  null
  
)

export default component.exports